import { LeaderboardDecoratedRow } from '.';
import Text from '../../../../atoms/Text';

interface ILeaderboardTableRowsProps {
  rows: LeaderboardDecoratedRow[];
  onRowClick(index: number): void;
  activeUser?: string;
}

const LeaderboardTableRows = ({
  rows,
  onRowClick,
  activeUser,
}: ILeaderboardTableRowsProps) => {
  return (
    <>
      {rows.map((row, index) => (
        <div
          key={row['#'].raw}
          className={`leaderboard_table__body__tr ${
            activeUser === row.Nickname.raw
              ? 'leaderboard_table__body__tr--active'
              : ''
          }`}
          onClick={() => onRowClick(row['#'].raw as number)}
        >
          {Object.keys(row).map((cellKey) => {
            const cellValue = row[cellKey].formatted;
            return (
              <div
                key={`${cellKey}-${index}`}
                className='leaderboard_table__body__tr__cell'
              >
                <Text size={12}>{cellValue}</Text>
              </div>
            );
          })}
        </div>
      ))}
    </>
  );
};

export default LeaderboardTableRows;
